const TuberCulosisConversation = `Good morning.
What brings you in today?
Hi, doc.
I've been having this persistent cough for a few weeks now.
It started off mild, but now I've been coughing up some blood.
I'm sorry to hear that.
Coughing up blood can be concerning.
Can you tell me more about any other symptoms you've been experiencing?
Yeah.
I've also had some night sweats, weight loss, and I feel tired all the time.
And, strangely, I've been having some pain in my left toe and occasional heartburn.
How long have you been experiencing the fatigue and night sweats?
I'd say about a month now.
And the weight loss, maybe over the last couple of months, I thought it was just due to my new diet.
Have you had any exposure to anyone diagnosed with tuberculosis, or have you recently traveled to areas where tuberculosis is common?
Now that you mentioned it, I did visit my cousin 3 months ago.
He was diagnosed with TB a few weeks after I came back, and I've been to South Africa for work about 5 months ago.
That's an important piece of information.
Tuberculosis is an infectious disease that can spread from person to person, especially in close quarters.
It's also more common in certain parts of the world, including parts of South Africa.
Oh, I see.
I didn't think much of the toe pain and heartburn, but I thought I'd mention it since I was here.
You did the right thing by mentioning all your symptoms.
Now given your exposure history and your current symptoms, I'm concerned about the possibility of you having tuberculosis.
We'll need to run some tests to confirm, including a chest X-ray and sputum test.
In the meantime, it's essential to ensure you practice good hygiene and avoid close contact with others, especially infants and those with weakened immune systems.
Alright.
I understand.
I'm just hoping we can get to the bottom of this soon.
We'll work together to ensure you get the right care and treatment.
Let's start with the tests and go from there.`;

const DiabetesConversation = `Good afternoon.
What brings you in today?
Hi, doctor.
I've been feeling extremely thirsty all the time, and no matter how much water I drink, it just doesn't seem to help.
I've also been going to the bathroom a lot more than usual, even during the night.
That sounds uncomfortable. How long have you been experiencing these symptoms?
It's been going on for about two months now.
At first, I thought it might just be because of the weather or stress, but it's getting worse.
I see. Aside from the thirst and frequent urination, have you noticed any other symptoms?
Yes, actually. I've been feeling really tired, even after a full night’s sleep. And recently, I've noticed some blurry vision, especially when I'm trying to read or use my phone.
That can be concerning. Have you experienced any unexplained weight loss or noticed any changes in your appetite?
Well, now that you mention it, I have lost some weight, but I haven’t been dieting or exercising more than usual. My appetite has been a bit strange too—sometimes I feel extremely hungry, even right after eating.
These are important symptoms. Excessive thirst, frequent urination, fatigue, unexplained weight loss, and blurry vision can all be signs of high blood sugar levels.
Have you or anyone in your family been diagnosed with diabetes before?
Yes, my father was diagnosed with type 2 diabetes a few years ago. I never thought it would affect me, though, since I try to stay active.
Family history can increase the risk of developing diabetes, especially type 2 diabetes. Given your symptoms and family history, I’d like to run a few tests to check your blood sugar levels.
What kind of tests are we talking about?
We'll start with a fasting blood glucose test and an A1C test, which will give us a better picture of your average blood sugar over the past few months. Depending on the results, we may need to explore further.
That makes sense. Is it something I should be really worried about?
Diabetes is a serious condition, but if it turns out you have it, there are many ways we can manage it through lifestyle changes, medication, or insulin therapy if needed. For now, I’d like to prescribe something to help manage your symptoms in the short term. For example, you can take 500mg of metformin once a day with your evening meal, which helps control blood sugar levels. Additionally, I’d recommend paracetamol (1000mg) at night to help with fatigue and any discomfort.
I see. I’ve been worried something might be wrong, but I didn’t realize it could be diabetes.
It’s good that you came in to get checked. Early diagnosis and management are key to living a healthy life with diabetes. We’ll take this one step at a time, starting with the tests.
Alright, I’m ready to do whatever it takes. I just want to feel better.
You’re doing the right thing by addressing it early. Let’s get these tests done, and we’ll go over the results together to figure out the next steps. In the meantime, take the medications I’ve prescribed, and let me know if your symptoms worsen or if you have any side effects.`;

const BreastCancerSurvivorshipConversation = `Good morning. It's good to see you again. This is your first shared care follow-up since you finished active treatment, so we'll go through everything today.
Thanks, doctor. It feels strange to be on this side of it, but I'm glad to be here.
Let's start with how you've been feeling overall. Any new symptoms or anything worrying you since we last met?
Mostly okay. I get tired in the afternoons, and I've had some aching in my joints, especially my hands and knees in the morning.
That joint stiffness is a common side effect of the anastrozole. Are you managing to take it every day?
Yes, one tablet each morning. I'll admit I thought about stopping because of the aches, but I haven't missed a dose.
I'm really glad you've kept it up, it's one of the most important things protecting you from the cancer coming back. We'll talk about ways to ease the joint pain. Any hot flushes or night sweats?
Some hot flushes, a few times a day. The nights are better than they were.
Okay. Let's quickly recap your history so it's on the record. You were diagnosed with early breast cancer in the left breast, hormone receptor positive and HER2 negative, and you had breast conserving surgery with a sentinel node biopsy, and the nodes were clear.
That's right. Then radiotherapy, and now the tablets for five years.
Exactly, no chemotherapy was needed. You're postmenopausal, and there's no strong family history, is that still the case?
Yes, no one else in the family that I know of.
Good. Now I'd like to examine you. I'm going to check both breasts, the surgical scar, and under the arms.
Of course.
The scar on the left has healed well, there are no new lumps or thickening, the skin looks healthy, and there's no nipple discharge. The lymph nodes under both arms and in your neck feel normal.
That's a relief to hear.
I'm also going to check your left arm for any swelling, since you had the node surgery on that side.
It has felt a bit heavy after I've been gardening.
There's no measurable swelling today, but that heaviness can be an early sign of lymphoedema, so let's keep an eye on it. If the arm feels tight or looks puffy, let me know promptly.
I will.
Let me ask about a few specific symptoms. Any new bone pain, a cough that won't settle, breathlessness, unexplained weight loss, or headaches?
No, nothing like that.
That's reassuring, those are the things we want to catch early. How are you coping emotionally? Many people find the fear of it returning is hardest once treatment ends.
Honestly, that's the part I struggle with. Every ache makes me worry, and I haven't been sleeping well.
That's completely understandable, and you're not alone in feeling that way. I can refer you to a counsellor who works with cancer patients, and there's a local survivorship support group if you'd like.
I think I'd like the counsellor, yes.
I'll organise that referral today. How are things at home and with work?
My husband's been wonderful. I've gone back to work three days a week, which feels about right for now.
That sounds like a good balance. Let's talk about a few things that lower the risk of recurrence, exercise, alcohol, and weight. How active are you?
I walk most days, but I stopped the gym during treatment.
Walking is great, and gentle resistance exercise will also help your joints and your bones. What about alcohol?
A glass of wine most nights.
I'd encourage cutting that back, a couple of nights a week at most, it does make a difference. Now, because the anastrozole can thin your bones, I'd like to arrange a bone density scan, a DXA, if you haven't had one recently.
I haven't, no.
We'll book that in. And your mammogram, you're due for your yearly one, so I'll order that as well and we'll compare it with last year's.
Okay, that all makes sense.
To summarise, keep taking the anastrozole daily, we'll arrange the counselling referral, a DXA scan, and your annual mammogram, and I'll see you again in six months for your next check, sooner if anything new comes up.
Thank you, doctor. It helps to have a clear plan.
You're doing all the right things. We'll work through this together.`;

const RightKneePainConversation = `Good morning. What brings you in today?
Hi, doc. It's my right knee. It's been bothering me for about three weeks now.
What happened around three weeks ago?
I rolled it stepping awkwardly off a curb. It swelled up that evening and it hasn't really settled since.
Where exactly does it hurt?
Mostly on the inside of the knee, along the joint line. It's worse when I twist or go down stairs.
Any locking, catching, or giving way?
It catches now and then, like something is in the way, and a couple of times it felt like it was going to buckle.
Have you been able to walk normally?
Not really. I've been limping, especially first thing in the morning.
Let me take a look. There's some swelling over the right knee compared to the left, and it's warm to touch.
Yeah, it's been puffy.
You're tender right here over the medial joint line. I'm going to bend and rotate the knee.
Ooh, that's it, right there.
That's a positive McMurray on the medial side. Your range of motion is limited, you're lacking about the last 10 degrees of flexion, and you've got an antalgic gait when you walk.
Is it serious?
It looks like a meniscus irritation with some joint effusion. The good news is most of these respond well to a structured rehab program.
What's the plan?
We'll start you on a progressive knee rehabilitation program, focused on settling the swelling, restoring full range of motion, and rebuilding the quad and hamstring strength so the knee feels stable again.
Okay, I just want to get back to walking without thinking about it.
That's exactly what we'll aim for. Let's get you started.`;

const RightHipPainConversation = `Good afternoon. What's going on today?
Hi, doctor. My right hip has been really painful for the last month or so.
Can you point to where it hurts?
Deep in the front of the hip, in the groin area. Sometimes it aches down toward the thigh.
Did anything bring it on?
Not one specific thing. It crept up over a few weeks. It's worst when I get up from a chair or try to put on my shoes and socks.
Any pain at night?
Yes, rolling onto that side wakes me up.
How's your walking?
I've started limping, especially after I've been sitting for a while.
Let me examine you. I'm going to move the right hip through its range. You're limited in internal rotation and flexion, and that recreates the groin pain.
Yeah, that pulls right where it hurts.
I'm bringing the leg into a figure-four position now.
That's uncomfortable too.
That's a positive FABER test on the right. You've also got an antalgic gait and reduced hip flexion to about 90 degrees.
So what is it?
This is consistent with right hip joint irritation and surrounding muscle weakness. We can manage this well with rehab rather than jumping to anything invasive.
What does that involve?
We'll put you on a hip rehabilitation program: restoring mobility, strengthening the glutes and deep hip stabilizers, and getting your gait back to normal.
Sounds good. I'd love to sleep through the night again.
Let's get you set up with that plan.`;

const RightShoulderPainConversation = `Hi there. What brings you in?
Morning, doc. It's my right shoulder. I can't lift my arm without it catching.
How long has this been going on?
About six weeks. It started after I spent a weekend painting the ceiling.
Where do you feel it?
On the top and outer part of the shoulder. It's worst when I reach overhead or try to grab something from a high shelf.
Does it bother you at night?
Definitely. I can't lie on that side, it wakes me up.
Let me take a look. Can you raise your arm out to the side for me?
It hurts right about here, halfway up.
That's a painful arc around 80 to 120 degrees. I'm going to do a couple of tests now.
Okay.
That's a positive Hawkins-Kennedy, and your empty can test is weak and painful on the right. Your active range is limited in abduction, though your passive range is better.
What does all that mean?
This points to a rotator cuff impingement on the right shoulder. There's no sign of a full tear, which is good.
How do we fix it?
We'll start a shoulder rehabilitation program, calming the inflammation first, then progressively strengthening the rotator cuff and scapular muscles and restoring your overhead reach.
Great, I just want to be able to reach the top shelf again.
That's a very achievable goal. Let's begin.`;

const ThoracicSpinePainConversation = `Good morning. What can I help with today?
Hi, doctor. I've got this nagging pain in my mid-back, right between my shoulder blades.
How long have you had it?
A couple of months now. I work at a desk all day and it's gotten steadily worse.
Can you describe the pain?
It's a deep, aching pain across the middle of my back. It gets tight and sometimes sharp when I take a deep breath or twist to reach behind me.
Does it travel anywhere or cause any numbness or tingling?
No, it stays right in the mid-back. No numbness, no weakness in my arms or legs.
Let me examine your back. I'm pressing along the thoracic spine here.
That's tender, especially right in the middle.
You've got tenderness over the thoracic paraspinal muscles and some tightness. Can you rotate your trunk for me, left and right?
Turning to the right pulls and feels stiff.
Your thoracic rotation is limited and extension reproduces the pain. Your neuro exam is completely normal.
So what's causing it?
This is mechanical thoracic spine pain, very common with prolonged desk posture. The muscles and mid-back joints have gotten stiff and deconditioned.
What's the plan?
We'll start you on a thoracic rehabilitation program: improving your mid-back mobility, strengthening the postural muscles, and addressing your workstation setup so it doesn't keep flaring up.
That would be a relief. It's hard to concentrate with it aching all day.
Let's get you started on that.`;

const PelvicPainConversation = `Hi, come on in. What brings you here today?
Thanks, doctor. I've been having pelvic pain for the past few months and it's really affecting my daily life.
I'm sorry to hear that. Can you tell me more about where you feel it?
It's low down in the pelvic area and the perineal region. A deep, aching pressure, and sometimes it's sore to sit for long periods.
How long has this been going on?
About four months now. It's been pretty constant, with some days worse than others.
Have you noticed anything that makes it better or worse?
Sitting for a long time makes it worse, and so does stress. It eases a bit when I move around or lie down.
Any associated urinary symptoms or pain with activity?
Some urgency, and there's discomfort with pelvic activity. Nothing that feels like an infection though.
Let me do a gentle examination to assess the pelvic floor.
Okay.
I can feel that the pelvic floor muscles are quite tight and tender on examination, and that reproduces the discomfort you've been describing.
So what does that tell us?
This is consistent with pelvic and perineal pain driven by pelvic floor muscle dysfunction, with the muscles holding too much tension.
Is that treatable?
Very much so. We'll put you on a pelvic health program: pelvic floor relaxation and retraining, breathing and posture work, and gradually building tolerance for sitting and activity.
That's reassuring. I was worried it would never get better.
It responds well to a structured program. Let's get you started.`;

const NeckPainConversation = `Good afternoon. What brings you in today?
Hi, doc. My neck has been killing me for a few weeks now.
Where exactly is the pain?
Across the back and sides of my neck, up toward the base of my skull. It's a tight, aching pain.
Did anything set it off?
Not really an injury. I've been working long hours hunched over my laptop and it just built up.
Does the pain go anywhere, like down into your arms?
No, it stays in the neck and the top of my shoulders. No numbness or tingling in my hands.
How's your movement?
Stiff. It's hard to check my blind spot when I'm driving, turning my head really pulls.
Let me examine you. I'm pressing along the muscles on either side of your neck.
That's sore, both sides.
You've got tenderness and some muscle spasm in the cervical paraspinals. Let's check your range of motion, turn left, now right, look up and down.
Turning and looking up are the tightest.
Your cervical range of motion is reduced in rotation and extension, but your strength, reflexes, and sensation in the arms are all normal.
So what is it?
This is mechanical neck pain, cervicalgia, from sustained posture and muscle strain. There's no sign of nerve involvement.
How do we treat it?
We'll start a cervical rehabilitation program: restoring your neck mobility, strengthening the deep neck and postural muscles, and sorting out your desk ergonomics.
Perfect. I just want to be able to turn my head without wincing.
That's exactly what we'll work toward. Let's begin.`;

const LowBackPainConversation = `Hi there. What can I do for you today?
Hi, doctor. It's my lower back. It's been aching on and off for months and I'm tired of it.
Can you describe the pain for me?
A dull, nagging ache across my lower back. Some days are fine, then it flares up and stiffens for a few days.
Does it shoot down your legs at all, or any numbness or tingling?
No, it stays in the low back. No pain down the legs, no numbness.
What tends to bring it on?
Long days on my feet, or bending over a lot. Sitting too long stiffens it up too.
Have you had any back surgery or major injury in the past?
No, nothing like that. Just this ongoing ache.
Let me have a look. I'm pressing along the muscles either side of your lower spine.
That's tender, kind of all across there.
You've got tenderness in the lumbar paraspinal muscles and they're a bit tight. Can you bend forward and reach toward your toes?
That's where it feels stiff and tight.
Your forward flexion is limited and a little guarded. Let me lift each leg while you lie back, tell me if anything shoots down.
No, that just feels like a normal stretch.
Good, your straight leg raise is negative on both sides and your neuro exam is normal.
So what's going on?
This is chronic, nonspecific low back pain, mostly muscular and related to deconditioning and how you load your back day to day. Nothing alarming.
What's the plan?
We'll get you on a low back maintenance program: core and hip strengthening, mobility work, and movement strategies so the flare-ups become less frequent and less intense.
That sounds great. I'd love to stop worrying about my back going out.
Let's get you started on that.`;

export const TestTranscripts = {
  tuberculosis: TuberCulosisConversation,
  diabetesWithMedicine: DiabetesConversation,
  breastCancerSurvivorship: BreastCancerSurvivorshipConversation,
  rightKneePain: RightKneePainConversation,
  rightHipPain: RightHipPainConversation,
  rightShoulderPain: RightShoulderPainConversation,
  thoracicSpinePain: ThoracicSpinePainConversation,
  pelvicPain: PelvicPainConversation,
  neckPain: NeckPainConversation,
  lowBackPain: LowBackPainConversation,
};
